import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/$lang/_layout/blog")({
  component: () => <Outlet />,
});
